<section class="container mb-0">
  <img src="assets/images/elvuelodeuno.jpg" alt="" class="img-responsive">
  <p class="text-center">Fecha de análisis: <strong>20/dic/2023</strong> - Sí el análisis no se visualiza correctamente <a href="https://app.us.luzmo.com/s/bhavani-2023-wh5trefqg0v22ehi">visualízalo aquí</a>.</p>
</section>
<section class="iframe-container ">
  <iframe class=" w-100 h-100" id="recap2023" [src]="'https://app.us.luzmo.com/s/bhavani-2023-wh5trefqg0v22ehi'|safeUrl"
    order="0" scrolling="no" allowfullscreen></iframe>
</section>